
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"32","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M27.25 11.469a7.01 7.01 0 010 9.948l-5.833 5.885c-.47.52-1.25.52-1.771.052-.469-.52-.469-1.302 0-1.77l5.833-5.938a4.527 4.527 0 000-6.406l-6.666-6.771c-.47-.469-.47-1.25.052-1.771a1.182 1.182 0 011.718.052l6.667 6.719zm-17.083-1.302c0 .937-.782 1.666-1.667 1.666-.938 0-1.667-.729-1.667-1.666 0-.886.73-1.667 1.667-1.667.885 0 1.667.781 1.667 1.667zm13.854 3.906a3.364 3.364 0 010 4.74l-6.927 6.927a3.364 3.364 0 01-4.74 0l-8.75-8.75c-.625-.625-.937-1.459-.937-2.344V6.833a2.5 2.5 0 012.5-2.5h7.76c.886 0 1.719.365 2.344.99l8.75 8.75zM5.167 6.833v7.813c0 .208.052.416.208.573l8.75 8.75a.793.793 0 001.198 0l6.927-6.927a.793.793 0 000-1.198l-8.75-8.75a.836.836 0 00-.573-.26h-7.76z"}})]);
        };
      

        module.exports = {
          
          render: render,
        };
      